import { z } from 'zod';
import { HttpsUrlSchema } from '../util/url.js';
/** Optional per-template subject overrides; keys match template families */
export const OwnerEmailSubjectsSchema = z.record(z.string(), z.string()).optional();
export const OwnerEmailEnvelopeSchema = z.object({
    commsFrom: z.string().min(1),
    defaultFromEmail: z.email(),
    defaultFromName: z.string().min(1),
    defaultSenderEmail: z.email(),
    emailReceivingDomain: z.string().min(3),
    emailSenderSuffix: z.string().startsWith('@'), // @mail.home.eigtech.io
    messagingFrom: z.string().min(1),
    notificationsFrom: z.string().min(1),
    welcomeFrom: z.string().min(1), // "EIG Claims <no-reply@...>"
    welcomeSender: z.email(),
});
export const OwnerFooterSchema = z.object({
    corporateOffice: z.string().min(1),
    customerServicePhone: z.string().min(1),
    inspectionSupportIvrHint: z.string().optional(), // ie. "select option 1 for Claims"
    regionalOffices: z.string().min(1), // ie. Florida Offices:\nJacksonville, Orlando, Tampa, and West Palm
    supportEmail: z.email(),
    websiteDisplay: z.string().min(1),
    websiteUrl: HttpsUrlSchema,
});
